module.exports = __webpack_public_path__ + "static/img/discover4.855062e9.jpg";